import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import ProductListCard from "../../components/common/Product-Listing-Card/Product-Listing-Card";
import "../../assets/css/product-list.css";
import { useSelector } from "react-redux";
import { getSampleCurrencyFormat, getUrlResolver } from "../../utils/utils";
import { saveProductlist } from "../../features/HomePageSlice/homeDataSlice";
import { endpoint } from "../../api/endpoint";
import { apiHandler } from "../../api";
import { PRODUCTLIST, CATEGORY_BREADCRUMBS, CATEGORY_INFO } from "../../assets/graphql";
import { useParams, useLocation } from "react-router-dom";
import Breadcrumb from "../../components/common/Breadcrumb/Breadcrumb";

import Loader from "../../components/common/Loader/loader";
import { BsApple } from "react-icons/bs";

const ProductList = () => {
  const imageData = localStorage.getItem("image")
  const [breadcrumbData, setBreadcrumbData] = useState({});
  const [selectedCategory, setSelectedCategory] = useState({}); 
  const [categoryName, setCategoryName] = useState("");
  const dispatch = useDispatch();
  const { url_key } = useParams();
  const locations = useLocation();

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 750);
  }, []);
  const { landingData } = useSelector((state) => state.home);

  const getCategoryInfo = async (id) => {
    // setLoader(true);
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: { id },
        query: CATEGORY_INFO,
      },
    });
    // setLoader(false);
    await setSelectedCategory(result.data.category);
  };

  const { productlist } = useSelector((state) => state.home);
  const getProductLists = async (id) => {
    // setLoader(true);
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: { id },
        query: PRODUCTLIST,
      },
    });
    // setLoader(false);
    if (!result.data.error_code) {
      const dataArray = landingData.categoriesProduct[0].selectedId.split(",");
      const filteredArray = result.data.products.items.filter((value) =>
        dataArray.includes(value.categories[0].id.toString())
      );
      dispatch(saveProductlist(filteredArray));
    }
  };
  const getBreadcrumb = async (id) => {
    // setLoader(true);
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: { id },
        query: CATEGORY_BREADCRUMBS,
      },
    });
    // setLoader(false);
    await setBreadcrumbData(result.data);
  };
  useEffect(() => {
    async function fetchData() {
      // You can await here
      let urlPath = locations && locations.state && locations.state.url_path ? locations.state.url_path : url_key;
      const result = await getUrlResolver(urlPath);
      if (result.route) {
        let id = result.route.id;
        getCategoryInfo(id);
        // CategoryInfo(id);
        getProductLists(id);
        getBreadcrumb(id);
      }
    }
    fetchData();
  }, [locations]);

  const getBreadCrumbData = () => {
    const { category } = breadcrumbData;

    let list = [];
    if (category) {
      list.push({ name: "Home", url: "/home" });
      category &&
        category.breadcrumbs &&
        category.breadcrumbs.forEach((cat) => {
          list.push({
            name: cat.category_name,
            url:
              category.display_subcategory === 1
                ? "/category-list/" + cat.category_url_key
                : "/product-list/" + cat.category_url_key,
          });
        });
      list.push({ name: category.name, url: "" });
    }
    return list;
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {/* <!-- Breadcrumb --> */}
          <section className="custombreadcrumb">
            <Breadcrumb data={getBreadCrumbData()} />
          </section>

          <section class="innertopbanner" style={{ backgroundColor: "#fff" }}>
            <img
              src={imageData || null}
              className="img-fluid"
            />
            <div class="text-overlay">
              <h2>SHOP WITH {selectedCategory?.name ? selectedCategory.name.toUpperCase() : ""}</h2>
            </div>
          </section>
          

          {/* <!-- Breadcrumb END --> */}
          <section className="pt-5 pb-5">
            <div className="container">
              {/* <h4 className="main-heading-inner">{selectedCategory?.name || ""}</h4> */}
              {productlist && productlist.length ? (
                <div className="row pt-4 gid-row-gap-style">
                  {productlist &&
                    productlist.map((product, index) => (
                      <div className="col-md-4 col-lg-4" key={index}>
                        <ProductListCard id={product.sku} ProductImg={product.image.url} ProductName={product.name} />
                      </div>
                    ))}
                </div>
              ) : (
                <>
                  <div className="commingsoon">
                    {/* <BsApple /> */}
                    Coming Soon...
                  </div>
                </>
              )}
            </div>
          </section>
        </>
      )}
      {/* {loader && (
                <div className='loading-overlay'>
                    <div className='bounce-loader'> */}
      {/* <div className='bounce1'></div>
								<div className='bounce2'></div>
								<div className='bounce3'></div> */}
      {/* <div className="loader"></div>
                    </div>
                </div>
            )} */}
    </>
  );
};
export default ProductList;
